import React from 'react';

const isProd = process.env.NODE_ENV === 'production';

const base = {
    helpMessage: (
        <span data-testid="help">If your vehicle isn’t listed, please reach out to your claim contact or agent.</span>
    ),
    placeholderClaimNumber: '0123456789',
    placeholderZipCode: '01234',
    zipCodeRegex: /^[0-9]{5}(?:-[0-9]{4})?$/,
    claimNumberRegex: /^[0-9]{9,12}$/,
    routes: {
        assetSelection: '/asset',
    },
    piClientLink: 'http://localhost:8999',
    serverBaseUrl: `${isProd ? '' : 'http://localhost:8099'}/api`,
};
export default base;
